import { useIntl } from 'react-intl';
import {
  ActiveListingFilter,
  BrandFilter,
  CoatingColorsFilter,
  GearTypeFilter,
  InteriorColorsFilter,
  ModelNamesFilter,
  PowerSupplyFilter,
  VehicleRegistrationDateISO8601Filter,
  EngineDisplacementInCM3Filter,
  PowerInHPFilter,
  PriceInEURFilter,
  PriceLabelsFilter,
  PriceTiedToLoanFilter,
  ProvinceFilter,
  RegionsFilter,
  TractionTypeFilter,
  VehicleCoveredByWarrantyFilter,
  VendorTypeFilter,
  VehicleKMFilter,
  VehicleTypeFilter,
  CountryFilter,
  ModelYearFilterSidebar,
} from 'sections/FiltersSidebar/';
import { CodesFilter } from 'sections/FiltersSidebar/CodesFilter';
import { ModelVersionsFilter } from 'sections/FiltersSidebar/ModelVersionsFilter';
import { WebsiteFilter } from 'sections/FiltersSidebar/WebsiteFilter';
import { SidebarAccordion } from '../SidebarAccordion';
import { OptionalFilters } from 'sections/FiltersSidebar/OptionalsFilter';
import { useLocation } from 'react-router';
import { ROUTES } from 'enums/ROUTES';
import * as S from './SideBar.styles';
import { WHITE_LABELS } from 'CONST';
import { EuiText } from '@elastic/eui';
import { PictureAvailableFilter } from 'sections/FiltersSidebar/PictureAvailableFilter';
import { VATDeductibleFilter } from 'sections/FiltersSidebar/VATDeductibleFilter';
const whiteLabel = window.WHITE_LABEL_CONFIG;
// eslint-disable-next-line @typescript-eslint/no-var-requires
const { THEME } = require(`white-label/themes/${whiteLabel.theme}`);

export const SideBar: (p: { sidebarIsOpen: boolean }) => JSX.Element = ({ sidebarIsOpen }) => {
  const { formatMessage } = useIntl();
  const { pathname } = useLocation();
  const isVisible = pathname !== ROUTES.priceCalculator;
  return (
    <S.SideBarContainer isActive={sidebarIsOpen}>
      <S.FiltersMain>
        <CodesFilter />
        <BrandFilter />
        <ModelYearFilterSidebar />
        <ModelNamesFilter />
        <ModelVersionsFilter />
        {whiteLabel?.name !== WHITE_LABELS.MOTORCYCLE && <OptionalFilters />}
      </S.FiltersMain>
      {/* PRINCIPAL INFO*/}
      <EuiText style={{ fontWeight: '500', marginLeft: '10px', marginTop: '20px' }}>
        {formatMessage({ id: 'advanced.filter', defaultMessage: 'Filtri avanzati' })}
      </EuiText>
      {isVisible ? (
        <SidebarAccordion label={formatMessage({ id: 'filter.principal-info' })} color={THEME.FILTERS_SECONDARY}>
          <VehicleRegistrationDateISO8601Filter />
          <VehicleKMFilter />
          {whiteLabel?.name !== WHITE_LABELS.MOTORCYCLE && <CountryFilter />}
          <RegionsFilter />
          <ProvinceFilter />
          <VendorTypeFilter />
          <PriceInEURFilter />
        </SidebarAccordion>
      ) : (
        <>
          {whiteLabel?.name !== WHITE_LABELS.MOTORCYCLE && <CountryFilter />}
          <RegionsFilter isDisabled={false} />
          <ProvinceFilter isDisabled={false} />
          <VendorTypeFilter />
        </>
      )}
      {/* TECHNICAL DETAIL */}
      {isVisible ? (
        <SidebarAccordion
          label={formatMessage({ id: 'filter.vehicle-technical-detail' })}
          color={THEME.FILTERS_PRIMARY}
        >
          <PowerInHPFilter />
          <EngineDisplacementInCM3Filter />
          <PowerSupplyFilter />
          <GearTypeFilter />
          {whiteLabel?.name !== WHITE_LABELS.MOTORCYCLE && (
            <>
              <TractionTypeFilter />
              <InteriorColorsFilter />
            </>
          )}
          <CoatingColorsFilter />
        </SidebarAccordion>
      ) : null}
      {/* WEB SEARCH */}
      {isVisible ? (
        <SidebarAccordion
          testId="filter.web-search.accordion"
          label={formatMessage({ id: 'filter.web-search' })}
          color={THEME.FILTERS_VARIANT}
        >
          <VehicleTypeFilter />
          <PriceLabelsFilter />
          <ActiveListingFilter />
          <WebsiteFilter />
          <PriceTiedToLoanFilter />
          <VehicleCoveredByWarrantyFilter />
          <PictureAvailableFilter />
          <VATDeductibleFilter />
        </SidebarAccordion>
      ) : null}
    </S.SideBarContainer>
  );
};
